import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagBZ = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M50 25c0-8.58-4.323-16.149-10.91-20.651L25 3.262 10.91 4.349C4.322 8.85 0 16.42 0 25c0 8.58 4.323 16.15 10.91 20.652L25 46.74l14.09-1.087C45.677 41.151 50 33.581 50 25.001Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#A2001D",
  d: "M39.09 4.348A24.882 24.882 0 0 0 25 0a24.882 24.882 0 0 0-14.09 4.348h28.18ZM10.91 45.653A24.883 24.883 0 0 0 25 50.001a24.883 24.883 0 0 0 14.09-4.348H10.91Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 36.956c6.604 0 11.957-5.354 11.957-11.957 0-6.604-5.353-11.957-11.957-11.957-6.603 0-11.956 5.353-11.956 11.957 0 6.603 5.353 11.957 11.956 11.957Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M25 34.782c5.403 0 9.783-4.38 9.783-9.782 0-5.403-4.38-9.783-9.783-9.783s-9.782 4.38-9.782 9.783c0 5.402 4.38 9.782 9.782 9.782Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 31.522a6.522 6.522 0 1 0 0-13.043 6.522 6.522 0 0 0 0 13.043Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M25 23.37 21.468 25v2.718L25 29.892l3.533-2.174v-2.717L25 23.37Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M21.468 21.738h7.065V25h-7.065v-3.26Z"
}));
FlagBZ.displayName = 'FlagBZ';
export default withFlagWrapper(FlagBZ);
//# sourceMappingURL=index.js.map